export type MaybeDate = Date | undefined | null;

export enum TPeriodOfDay {
  MORNING,
  AFTERNOON,
  EVENING,
  NIGHT,
}
